module.exports = __webpack_public_path__ + "img/制御工学7_5.b2a20695.png";